import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'app-sector-section-button',
  standalone: true,
  imports: [NgStyle, NgClass],
  templateUrl: './sector-section-button.component.html',
  styleUrl: './sector-section-button.component.scss',
})
export class SectorSectionButtonComponent {
  @Input({ required: true }) artifactName!: string;
  @Input({ required: true }) artifactCount!: number;

  @Output() onArtifactSelect = new EventEmitter<string>();

  onArtifactClick() {
    this.onArtifactSelect.emit(this.artifactName);
  }
}
